import activity1 from '../assets/activities/activity1.jpg';
import activity1_1 from '../assets/activities/activity1_1.jpg';
import activity2 from '../assets/activities/activity2.jpg';
import activity3 from '../assets/activities/activity3.jpg';
import activity4 from '../assets/activities/activity4.jpg';
import activity4_1 from '../assets/activities/activity4_1.jpg';
import activity5 from '../assets/activities/activity5.jpg';
import activity6 from '../assets/activities/activity6.jpg';
import activity7 from '../assets/activities/activity7.jpg';
import activity7_1 from '../assets/activities/activity7_1.jpg';

export const activities = [
    {
      image: [activity1, activity1_1],
      date: "May 02, 2020",
      title: "The Minister of Industry",
      description: "Visit of His Excellency the Minister of Industry, Engineer Imad Hoballah, to the Mediterranean Cables factory in Teffahta - South Lebanon"
    },
    {
      image: [activity2],
      date: "September 27, 2019",
      title: "Dinner",
      description: "MedCables hosted a dinner with the Ambassador of the People's Republic of China to celebrate their National Day."
    },
    {
      image: [activity3],
      date: "August 04, 2019",
      title: "Hosting Chinese delegation",
      description: "MedCables hosted a large Chinese economic delegation. The delegation included the Economic and Commercial Counselor at the Chinese Embassy in Lebanon, Li Jing, and a large team from the embassy. They were received by Mr. Ahmad Kothrani. The delegation received presentations on the company's business and economic challenges and toured the factory."
    },
    {
        image: [activity4, activity4_1],
        date: "August 04, 2019",
        title: "Interactive Ceremony",
        description: "MedCables honored the Minister of Industry, Dr. Hussein Hajj Hassan, in a ceremony at the Malaak Tourist Complex in Ansariyah. The event was attended by prominent industrial and municipal figures. Speeches were delivered by Mr. Samer Zbeib, MedCables CEO Ahmad Kothrani, Dr. Fadi Jameel, and Minister Hussein Hajj Hassan. The ceremony concluded with the presentation of an honorary shield to the Minister."
    },
    {
      image: [activity5],
      date: "August 04, 2019",
      title: "Lunch Meeting",
      description: "A gathering over lunch is scheduled, with the presence of the CEO of the Mediterranean Company, the director of the research laboratory, and the president of the Chamber of Commerce and Industry."
    },   
    {
      image: [activity6],
      date: "August 04, 2019",
      title: "Meeting",
      description: "A meeting was held in the presence of the MedCables's director, the Algerian ambassador, and the Tunisian ambassador."
    },
    {
      image: [activity7, activity7_1],
      date: "June 24, 2023",
      title: "Minister of Labor Visits Our Factory",
      description: "Minister of Labor Mustafa Bayram and his delegation visited MedCables to tour its factory, reflecting his strong support for the industrial sector and local businesses. MedCables is recognized as a model company in its field, creating sustainable job opportunities for youth and contributing to economic development. The visit highlights the importance of collaboration between the Ministry of Labor and the private sector to drive progress."
    },
  ];
